'use es6';
/* MON569 */

export const MON569_PARAMETER_OPTIONS = {
  CONTROL: 'control',
  STARTER: 'starter',
  ADVANCED: 'advanced'
};
/* MON607 */

export const MON607_PARAMETER_OPTIONS = {
  CONTROL: 'control',
  VARIANT1: 'variant1',
  VARIANT2: 'variant2'
};
/* MON606 */

export const MON606_TREATMENT_KEY = 'cbx-606';
export const MON606_PUBLIC_TREATMENT_KEY = 'cbx-606p';
export const MON606_PARAMETER_KEY = 'group';
export const MON606_PARAMETER_OPTIONS = {
  CONTROL: 'control',
  VARIANT: 'variant'
};